import { useLocation, useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaUniversity,
  FaMoneyCheck,
  FaExchangeAlt,
  FaMoneyBillWave,
  FaRegEdit,
} from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import moment from "moment";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import Loading from "../../components/spinner/Loading";
import TopupRequestForm from "./TopupRequestForm";
import { getTopupRequestByID } from "./services/topup.services";
import TopupReqDelete from "./TopupReqDelete";
import { clearTopupRequestDetails } from "./topupSlice";

const TopupRequestView = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isEdit, setIsEdit] = useState(false);

  const loading = useAppSelector((state) => state.topup.loading);
  const topupRequestDetails = useAppSelector(
    (state) => state.topup.TopupRequestDetail
  );

  useEffect(() => {
    if (location?.state?.ID) dispatch(getTopupRequestByID(location.state.ID));

    return () => {
      dispatch(clearTopupRequestDetails());
    };
  }, [dispatch, location?.state?.ID]);

  const renderTypeSpecificFields = () => {
    const { Type } = topupRequestDetails;

    switch (Type) {
      case "Cheque":
        return (
          <>
            <div className="d-flex mb-3">
              <FaMoneyCheck
                className="me-2"
                style={{ color: "#00a34d", marginTop: 3, fontSize: 16 }}
              />
              <div>
                <p className="text-muted mb-0">Cheque No</p>
                <p className="fw-bold mb-0">
                  {topupRequestDetails.ChequeNo || "-"}
                </p>
              </div>
            </div>

            <div className="d-flex mb-3">
              <FaUniversity
                className="me-2"
                style={{ color: "#00a34d", marginTop: 3, fontSize: 16 }}
              />
              <div>
                <p className="text-muted mb-0">Bank Name</p>
                <p className="fw-bold mb-0">
                  {topupRequestDetails.BankName || "-"}
                </p>
              </div>
            </div>

            <div className="d-flex mb-3">
              <div style={{ width: "160px" }}>
                <p className="text-muted mb-0">Cheque Branch</p>
              </div>
              <div>
                <p className="fw-bold mb-0">
                  {topupRequestDetails.ChequeBranchName || "-"}
                </p>
              </div>
            </div>

            <div className="d-flex mb-3">
              <div style={{ width: "160px" }}>
                <p className="text-muted mb-0">Account Holder Name</p>
              </div>
              <div>
                <p className="fw-bold mb-0">
                  {topupRequestDetails.AccHoloderName || "-"}
                </p>
              </div>
            </div>

            <div className="d-flex mb-3">
              <div style={{ width: "160px" }}>
                <p className="text-muted mb-0">Account No</p>
              </div>
              <div>
                <p className="fw-bold mb-0">
                  {topupRequestDetails.AccountNo || "-"}
                </p>
              </div>
            </div>
          </>
        );

      case "Net Transfer":
        return (
          <>
            <div className="d-flex mb-3">
              <FaExchangeAlt
                className="me-2"
                style={{ color: "#00a34d", marginTop: 3, fontSize: 16 }}
              />
              <div>
                <p className="text-muted mb-0">Transaction No</p>
                <p className="fw-bold mb-0">
                  {topupRequestDetails.TransactionNo || "-"}
                </p>
              </div>
            </div>

            <div className="d-flex mb-3">
              <div style={{ width: "160px" }}>
                <p className="text-muted mb-0">Net Transfer ID</p>
              </div>
              <div>
                <p className="fw-bold mb-0">
                  {topupRequestDetails.NetTransferID || "-"}
                </p>
              </div>
            </div>

            <div className="d-flex mb-3">
              <FaUniversity
                className="me-2"
                style={{ color: "#00a34d", marginTop: 3, fontSize: 16 }}
              />
              <div>
                <p className="text-muted mb-0">Bank Name</p>
                <p className="fw-bold mb-0">
                  {topupRequestDetails.BankName || "-"}
                </p>
              </div>
            </div>
          </>
        );

      case "Cash":
        return (
          <>
            <div className="d-flex mb-3">
              <FaMoneyBillWave
                className="me-2"
                style={{ color: "#00a34d", marginTop: 3, fontSize: 16 }}
              />
              <div>
                <p className="text-muted mb-0">Deposited Bank</p>
                <p className="fw-bold mb-0">
                  {topupRequestDetails.DepositedBankName || "-"}
                </p>
              </div>
            </div>

            <div className="d-flex mb-3">
              <div style={{ width: "160px" }}>
                <p className="text-muted mb-0">Deposited Branch</p>
              </div>
              <div>
                <p className="fw-bold mb-0">
                  {topupRequestDetails.DepositedBranch || "-"}
                </p>
              </div>
            </div>

            <div className="d-flex mb-3">
              <div style={{ width: "160px" }}>
                <p className="text-muted mb-0">Transaction No</p>
              </div>
              <div>
                <p className="fw-bold mb-0">
                  {topupRequestDetails.TransactionNo || "-"}
                </p>
              </div>
            </div>

            <div className="d-flex mb-3">
              <div style={{ width: "160px" }}>
                <p className="text-muted mb-0">Deposited Mode</p>
              </div>
              <div>
                <p className="fw-bold mb-0">
                  {topupRequestDetails.DepositedMode || "-"}
                </p>
              </div>
            </div>
          </>
        );

      case "Other":
        return (
          <>
            <div className="d-flex mb-3">
              <div style={{ width: "160px" }}>
                <p className="text-muted mb-0">Deposited Mode</p>
              </div>
              <div>
                <p className="fw-bold mb-0">
                  {topupRequestDetails.DepositedMode || "-"}
                </p>
              </div>
            </div>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Loading loading={loading} />
      <TopupReqDelete ID={location?.state?.ID} isViewMode={true} />
      <div className="container py-4">
        <div className="d-flex align-items-center mb-4">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-link me-3"
            style={{
              color: "#00a34d",
              background: "white",
              padding: "8px",
              borderRadius: 6,
              border: "1px solid #e6f4ea",
            }}
          >
            <FaArrowLeft size={20} />
          </button>
          <h2 className="mb-0">Top-Up Request Details</h2>
        </div>

        <div className="card border-0 shadow-sm">
          {!isEdit ? (
            <div className="card-body p-4">
              {/* Header Section with Status and Actions */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <span
                  className="badge text-white py-2 px-3"
                  style={{
                    backgroundColor:
                      topupRequestDetails.RequestStatus === "Pending"
                        ? "goldenrod"
                        : topupRequestDetails.RequestStatus === "Rejected"
                        ? "lightcoral"
                        : "#00a34de6",
                    fontSize: "0.9rem",
                    borderRadius: "20px",
                  }}
                >
                  {topupRequestDetails.RequestStatus}
                </span>

                {topupRequestDetails.RequestStatus === "Pending" && (
                  <div>
                    <FaRegEdit
                      className="me-3 traveller-icon"
                      title="Edit"
                      onClick={() => setIsEdit(true)}
                      style={{
                        cursor: "pointer",
                        fontSize: "1.2rem",
                        color: "#00a34d",
                      }}
                    />
                    <RiDeleteBin6Line
                      className="traveller-icon red-color"
                      data-bs-toggle="modal"
                      data-bs-target="#topuprequestdelete"
                      title="Delete"
                    />
                  </div>
                )}
              </div>

              {/* Top-up Details */}
              <div className="row">
                {/* Left Column - Transaction Details */}
                <div className="col-md-6">
                  <div className="mb-4">
                    <h5 className="mb-3 section-title">Transaction Details</h5>

                    {/* Common Fields for All Types */}
                    <div className="d-flex mb-3">
                      <div style={{ width: "160px" }}>
                        <p className="text-muted mb-0">Request Date</p>
                      </div>
                      <div>
                        <p className="mb-0 fw-bold">
                          {topupRequestDetails.TransactionDate
                            ? moment(
                                topupRequestDetails.TransactionDate
                              ).format("DD MMM YYYY")
                            : "-"}
                        </p>
                      </div>
                    </div>

                    <div className="d-flex mb-3">
                      <div style={{ width: "160px" }}>
                        <p className="text-muted mb-0">Top-Up Type</p>
                      </div>
                      <div>
                        <p className="mb-0 fw-bold text-capitalize">
                          {topupRequestDetails.Type || "-"}
                        </p>
                      </div>
                    </div>

                    <div className="d-flex mb-3">
                      <div style={{ width: "160px" }}>
                        <p className="text-muted mb-0">Amount</p>
                      </div>
                      <div>
                        <p className="mb-0 fw-bold">
                          ₹{" "}
                          {topupRequestDetails.Amount?.toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                          }) || "0.00"}
                        </p>
                      </div>
                    </div>

                    <div className="d-flex mb-3">
                      <div style={{ width: "160px" }}>
                        <p className="text-muted mb-0">Transaction Date</p>
                      </div>
                      <div>
                        <p className="mb-0 fw-bold">
                          {topupRequestDetails.TransactionDate
                            ? moment(
                                topupRequestDetails.TransactionDate
                              ).format("DD MMM YYYY")
                            : "-"}
                        </p>
                      </div>
                    </div>

                    {/* Type Specific Fields */}
                    {renderTypeSpecificFields()}

                    <div className="d-flex mb-3">
                      <div style={{ width: "160px" }}>
                        <p className="text-muted mb-0">Remarks</p>
                      </div>
                      <div>
                        <p className="mb-0">
                          {topupRequestDetails.Remarks || "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Column - Additional Details */}
                <div className="col-md-6">
                  <div className="mb-4">
                    <h5 className="mb-3 section-title">Additional Details</h5>

                    {/* Deposited Bank Details (for Cheque and Cash) */}
                    {(topupRequestDetails.Type === "Cheque" ||
                      topupRequestDetails.Type === "Cash") && (
                      <div className="d-flex mb-3">
                        <div style={{ width: "160px" }}>
                          <p className="text-muted mb-0">Deposited Bank</p>
                        </div>
                        <div>
                          <p className="fw-bold mb-0">
                            {topupRequestDetails.DepositedBankName || "-"}
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Deposited Bank Details for Net Transfer */}
                    {topupRequestDetails.Type === "Net Transfer" && (
                      <div className="d-flex mb-3">
                        <div style={{ width: "160px" }}>
                          <p className="text-muted mb-0">Deposited Bank</p>
                        </div>
                        <div>
                          <p className="fw-bold mb-0">
                            {topupRequestDetails.DepositedBankName || "-"}
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Request Status Remarks */}
                    {topupRequestDetails.RequestStatusRemarks && (
                      <div
                        className="mt-4 p-3 rounded"
                        style={{ backgroundColor: "#f8f9fa" }}
                      >
                        <h6 className="mb-2" style={{ color: "#00a34d" }}>
                          Admin Remarks
                        </h6>
                        <p className="mb-0 text-muted">
                          {topupRequestDetails.RequestStatusRemarks}
                        </p>
                      </div>
                    )}

                    {/* Created/Updated Info */}
                    <div className="mt-4">
                      <div className="d-flex mb-2">
                        <div style={{ width: "160px" }}>
                          <p className="text-muted mb-0 small">Created By</p>
                        </div>
                        <div>
                          <p className="mb-0 small fw-bold">
                            {topupRequestDetails.CreatedBy || "-"}
                          </p>
                        </div>
                      </div>

                      <div className="d-flex">
                        <div style={{ width: "160px" }}>
                          <p className="text-muted mb-0 small">Created Date</p>
                        </div>
                        <div>
                          <p className="mb-0 small fw-bold">
                            {topupRequestDetails.CreatedDate
                              ? moment(
                                  topupRequestDetails.CreatedDate,
                                  "YYYY-MM-DD HH:mm"
                                ).format("DD MMM YYYY, hh:mm A")
                              : "-"}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Approved Info */}
                    {(topupRequestDetails?.ApprovedBy ||
                      topupRequestDetails?.ApprovedDate) && (
                      <div className="mt-4">
                        {topupRequestDetails?.ApprovedBy && (
                          <div className="d-flex mb-2">
                            <div style={{ width: "160px" }}>
                              <p className="text-muted mb-0 small">
                                {topupRequestDetails.RequestStatus ===
                                "Rejected"
                                  ? "Rejected"
                                  : "Approved"}{" "}
                                By
                              </p>
                            </div>
                            <div>
                              <p className="mb-0 small fw-bold">
                                {topupRequestDetails.ApprovedBy || "-"}
                              </p>
                            </div>
                          </div>
                        )}

                        {topupRequestDetails?.ApprovedDate && (
                          <div className="d-flex">
                            <div style={{ width: "160px" }}>
                              <p className="text-muted mb-0 small">
                                {topupRequestDetails.RequestStatus ===
                                "Rejected"
                                  ? "Rejected"
                                  : "Approved"}{" "}
                                Date
                              </p>
                            </div>
                            <div>
                              <p className="mb-0 small fw-bold">
                                {topupRequestDetails.ApprovedDate
                                  ? moment(
                                      topupRequestDetails.ApprovedDate,
                                      "YYYY-MM-DD HH:mm"
                                    ).format("DD MMM YYYY, hh:mm A")
                                  : "-"}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="card-body p-4">
              <TopupRequestForm isViewMode={true} setIsEdit={setIsEdit} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default TopupRequestView;
